import React from 'react';
import './About.css';

const About = () => {
  return (
    <section className="about" id="about">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <div className="section-header">
              <h2>About AlphaTech</h2>
              <p>Professional Wireless Monitoring Solutions</p>
            </div>
            <div className="about-description">
              <p>
                AlphaTech specializes in cutting-edge wireless monitoring solutions, providing 
                advanced temperature and water level monitoring systems for various industrial, 
                commercial, and residential applications. Our expertise lies in developing reliable, 
                accurate, and maintenance-free monitoring systems that meet the demanding requirements 
                of modern smart infrastructure.
              </p>
              <p>
                Our comprehensive wireless monitoring solutions include temperature controllers, 
                water level indicators with alarm systems, and complete IoT-enabled monitoring 
                platforms. We design and manufacture systems that combine precision engineering 
                with user-friendly interfaces, ensuring optimal performance and peace of mind 
                for our customers.
              </p>
            </div>
            <div className="about-mission">
              <h3>Our Expertise</h3>
              <p>
                With extensive experience in wireless monitoring technology, we deliver 
                solutions that combine accuracy, reliability, and longevity. Our systems 
                eliminate complex installations while providing precise monitoring and 
                control for critical applications including water management and climate control.
              </p>
            </div>
          </div>
        </div>

        <div className="values-section">
          <h3>Why Choose Us</h3>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">🎯</div>
              <h4>Precision</h4>
              <p>Accurate monitoring with advanced wireless technology for temperature and water levels</p>
            </div>
            <div className="value-card">
              <div className="value-icon">🤝</div>
              <h4>Reliability</h4>
              <p>Dependable systems with 10-year battery life and weather-resistant design</p>
            </div>
            <div className="value-card">
              <div className="value-icon">⚡</div>
              <h4>Efficiency</h4>
              <p>Easy installation and maintenance-free operation with wireless connectivity</p>
            </div>
            <div className="value-card">
              <div className="value-icon">💡</div>
              <h4>Innovation</h4>
              <p>Latest IoT and wireless technology for smart water and temperature management</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
